import { call, delay, put, takeLatest } from "redux-saga/effects";
import {} from "../../interfaces";
import {
  CREATE_FLIGHT_ORDER,
  FETCH_DEAL_FLIGHTS,
  SEARCH_FLIGHTS,
} from "./types";
import {
  createOrder,
  fetchDealFlights,
  fetchFlightOffersByGet,
  fetchFlightOffersByPost,
} from "../../services";
import {
  removeFlights,
  setBookedFlight,
  setDealFlights,
  setFilteredFlights,
  setFlights,
} from "./actions";
import { setAlert } from "../alert";
import { removeLoader, setLoader } from "../loader";
import { setCurrentRoute } from "../router";
import {
  handleFetchAmadeusToken,
  setAmaClientRef,
  setSearchModel,
  setTempModel,
  store,
} from "src/store";
import { filterListData } from "src/views/flightsList/constants";
import isEqual from "lodash/isEqual";
import { v4 as uuidv4 } from "uuid";

let lastPayload: any = null;

// function* handleFlightOffers({ payload }: { payload: any }): Generator<any> {
//   const model = store?.getState()?.searchModel;
//   const tempModel = store?.getState()?.tempModel;
//   yield put(setTempModel({ ...tempModel, searching: true }));

//   const token = yield call(handleFetchAmadeusToken);
//   const amaClientRef = uuidv4();
//   yield put(setAmaClientRef(amaClientRef));

//   if (model?.filtering) {
//     yield put(setLoader({ transparent: true, visible: true }));
//   }

//   if (!model?.filtering && !model?.localFiltering) {
//     yield put(removeFlights());
//   }

//   try {
//     const responseData: any = yield call(fetchFlightOffersByPost as any, payload, token);

//     if (!model?.filtering && !model?.localFiltering) {
//       yield put(setFlights(responseData));
//     } else {
//       yield put(setFilteredFlights(responseData));
//     }

//     yield put(setSearchModel({ ...payload, searching: false }));

//     if (model?.filtering && model?.localFiltering) {
//       const filteredItems = filterListData(responseData, {
//         duration: model?.duration,
//         outbound: model?.outbound,
//         outboundTime: model?.outboundTime,
//         minOutboundTime: payload?.minOutboundTime,
//         layover: model?.layover,
//       } as any);
//       yield put(setFilteredFlights(filteredItems));
//     }

//     if (responseData?.meta?.count === 0) {
//       yield put(setAlert({ text: "Flights not found", type: "warning" }));
//     }
//   } catch (error) {
//     yield put(setAlert({ text: error?.message, type: "error" }));
//   }

//   yield put(setTempModel({ ...tempModel, searching: false }));
//   yield put(removeLoader());
// }

function* handleFlightOffers({ payload }: { payload: any }): Generator<any> {
  const model = store?.getState()?.searchModel;
  const tempModel = store?.getState()?.tempModel;

  yield put(setTempModel({ ...tempModel, searching: true }));

  const token = yield call(handleFetchAmadeusToken);

  const amaClientRef = uuidv4();
  yield put(setAmaClientRef(amaClientRef));

  if (model?.filtering) {
    yield put(setLoader({ transparent: true, visible: true }));
  }

  if (!model?.filtering && !model?.localFiltering) {
    yield put(removeFlights());
  }

  try {
    const responseData: any = yield call(
      fetchFlightOffersByPost as any,
      payload,
      token
    );

    if (!model?.filtering && !model?.localFiltering) {
      yield put(setFlights(responseData));
    } else {
      yield put(setFilteredFlights(responseData));
    }

    yield put(setSearchModel({ ...payload, searching: false }));

    if (model?.filtering && model?.localFiltering) {
      const filteredItems = filterListData(responseData, {
        duration: model?.duration,
        outbound: model?.outbound,
        outboundTime: model?.outboundTime,
        minOutboundTime: payload?.minOutboundTime,
        layover: model?.layover,
      } as any);

      yield put(setFilteredFlights(filteredItems));
      console.log(
        "Applied additional local filtering, filtered items:",
        filteredItems
      );
    }

    if (responseData?.meta?.count === 0) {
      yield put(setAlert({ text: "Flights not found", type: "warning" }));
      console.warn("No flights found for the given criteria");
    }
  } catch (error) {
    console.error("Error fetching flight offers:", error);
    yield put(setAlert({ text: error?.message, type: "error" }));
  }

  yield put(setTempModel({ ...tempModel, searching: false }));
  console.log("Set tempModel searching to false");

  yield put(removeLoader());
  console.log("Removed loader, handleFlightOffers finished");
}

let pricedata = {};
function* handleDealFlight(payload: any, title): Generator<any> {
  const token = yield call(handleFetchAmadeusToken);
  const responseData: any = yield call(fetchDealFlights as any, payload, token);
  const finalData = {
    [title]: responseData,
  };
  const deals = store?.getState()?.flights?.deals;
  pricedata = { ...pricedata, ...deals, ...finalData };
  yield put(setDealFlights(pricedata));
}
function* handleDealFlights({ payload }: { payload: any }): Generator<any> {
  yield put(setLoader({ transparent: true, visible: true }));
  try {
    for (let i = 0; i <= 3; i++) {
      yield call(
        handleDealFlight,
        {
          ...payload,
          origin: payload?.originDestinations[i]?.origin,
          destination: payload?.originDestinations[i]?.destination,
        },
        payload?.originDestinations[i]?.origin +
          "-" +
          payload?.originDestinations[i]?.destination
      );
    }
  } catch (error) {}
  yield put(removeLoader());
}

function* handleFlightOrder({ payload }: { payload: any }): Generator<any> {
  try {
    const token = yield call(handleFetchAmadeusToken);
    yield put(setLoader({ transparent: true }));
    const responseData: any = yield call(createOrder as any, payload, token);
    yield put(setBookedFlight(responseData));
    yield put(setCurrentRoute({ path: "/flight-booking-success" }));
  } catch (error) {}
  yield put(removeLoader());
}

export function* flightSaga() {
  yield takeLatest<any>(SEARCH_FLIGHTS, handleFlightOffers);
  yield takeLatest<any>(FETCH_DEAL_FLIGHTS, handleDealFlights);
  yield takeLatest<any>(CREATE_FLIGHT_ORDER, handleFlightOrder);
}
